import React from 'react'
import { helper } from '../utilities/helper'
import PicCont from './PicCont'
import { useSelector } from 'react-redux'
import { getMedia } from '../store/slices/user'
import singleModule from '../public/Pictures/singleModule.png'
import hsegment from '../public/Pictures/hsegment.png'
import colLeft from '../public/Pictures/colLeft.png'
import colRight from '../public/Pictures/colRight.png'
import legLeft from '../public/Pictures/legLeft.png'
import legRight from '../public/Pictures/legRight.png'

const WallRender = ({sel,  sHeight, height, width}) => {


  //  console.log('HEIGHT', type)

  return    <div className={`wallRender ${sel} ${height > 3.5 || width > 3.5 ? 'shortTop' : ''} ${height > 5.5 || width > 5.5 ? 'xxl' : ''}`}>
   
  
              {/* <PicCont height={900} width={900} picture={`${sel === 'msr' ? 'm' : ''}${String(width / (sel ==='msr' ? 8 :4))}x${height /4}.png`} /> */}
              {sel === 'rigged' && <div className='truss'>
                  <div className='trussCol'>
                  <PicCont width={50} height={210}  src={colLeft} className={height > 3.5 || width > 3.5 ? 'small' : ''} />
                  {helper.makeSeries(Number(sHeight ==2 && height == 1.5 ?1 : Math.ceil(((height*2)/4))+(Math.ceil(sHeight-height))-1), 0).map(c =>       <PicCont  key={'ll'+c} width={51} height={140}  src={legLeft} className={height > 3.5 || width > 3.5 ? 'leg small' : 'leg'} />)}
                      </div>
                  <div className='trussCenter' >
                  {helper.makeSeries(Number(Math.ceil((width*2)/2)), 0).map(c => <div className='trussSegment' key={'t' + c}>
        
                      <PicCont width={100} height={55}  src={hsegment} className={height > 3.5 || width > 3.5 ? 'small' : ''} />
               
                  </div>)}
                  </div>
                  <div className='trussCol'>
                  <PicCont width={50} height={210}  src={colRight} className={height > 3.5 || width > 3.5 ? 'small' : ''} />
                  {helper.makeSeries(sHeight ==2 && height == 1.5 ?1 : Number(Math.ceil(((height*2)/4))+(Math.ceil(sHeight-height))-1), 0).map(c =>       <PicCont  key={'ll'+c} width={51} height={140}  src={legRight} className={height > 3.5 || width > 3.5 ? 'leg small' : 'leg'} />)}
                      </div>
                  </div>}
              <div className={`vidWall ${sel}`}>
              
                  {helper.makeSeries(width*2, 0).map(c => <div className='vwCol' key={'c' + c}>
                      {helper.makeSeries(height*2, 0).map(r => <div className='vwRow' key={'r' + r}>
                      <PicCont width={50} height={50}  src={singleModule} className={height > 3.5 || width > 3.5 ? 'small' : ''} />
                      </div>)}
                  </div>)}
  
              </div>
          </div>
}

export default WallRender
